import emptyStateImage from "$assets/images/empty-state.svg?url";
import { Grid, styled, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const EmptyStateContainer = styled(Grid)(() => ({
  textAlign: "center",
}));
const EmptyStateImage = styled("img")(() => ({
  margin: "20px auto",
  width: "100px",
}));

const EmptyPriceListState = () => {
  return (
    <EmptyStateContainer item xs={12}>
      <Grid>
        <EmptyStateImage src={emptyStateImage} alt="" />
        <Typography variant="body1">
          <b>
            <FormattedMessage
              id="pricelist.emptyPriceListState.title"
              defaultMessage="Your price list contains no items yet"
            />
          </b>
        </Typography>
      </Grid>
    </EmptyStateContainer>
  );
};

export default EmptyPriceListState;
